import React from "react";
import { Container, Flags, Flag } from "./styles";
import HeaderLogo from "./Logo";
import {
  Default,
  Hamburg,
  Alianca,
  FlagBr,
  FlagEn,
  FlagEs
} from "../../assets/images";

function Header({ handleChangeLanguage, backgroundColor, tenantId }) {
  function handleLogo() {
    const isHamburg = process.env.REACT_APP_ENVIRONMENT === "hamburg";
    if (isHamburg && tenantId === 2) {
      return Alianca;
    } else if (isHamburg) {
      return Hamburg;
    } else {
      return Default;
    }
  }

  const logo = handleLogo();

  return (
    <Container backgroundColor={backgroundColor}>
      <HeaderLogo src={logo} />
      <Flags>
        <Flag
          id="br"
          src={FlagBr}
          alt="flag br"
          onClick={() => handleChangeLanguage("pt")}
        />
        <Flag
          id="en"
          src={FlagEn}
          alt="flag en"
          onClick={() => handleChangeLanguage("en")}
        />
        <Flag
          id="es"
          src={FlagEs}
          alt="flag es"
          onClick={() => handleChangeLanguage("es")}
        />
      </Flags>
    </Container>
  );
}

export default Header;
